/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartResponseDto } from './PartResponseDto';
import {
    PartResponseDtoFromJSON,
    PartResponseDtoFromJSONTyped,
    PartResponseDtoToJSON,
    PartResponseDtoToJSONTyped,
} from './PartResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListPartsResponseDto
 */
export interface ListPartsResponseDto {
    /**
     * 
     * @type {Array<PartResponseDto>}
     * @memberof ListPartsResponseDto
     */
    data: Array<PartResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListPartsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListPartsResponseDto interface.
 */
export function instanceOfListPartsResponseDto(value: object): value is ListPartsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListPartsResponseDtoFromJSON(json: any): ListPartsResponseDto {
    return ListPartsResponseDtoFromJSONTyped(json, false);
}

export function ListPartsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPartsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PartResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListPartsResponseDtoToJSON(json: any): ListPartsResponseDto {
    return ListPartsResponseDtoToJSONTyped(json, false);
}

export function ListPartsResponseDtoToJSONTyped(value?: ListPartsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PartResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

